module.exports = __webpack_public_path__ + "img/plexus-7.b74cb7c0.png";